import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SanitizerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sanitizer"}/>
}
